import moment from "moment-timezone";

export const mapOpenShiftRequest = (request: any, timezone: string) => ({
    ...request,
    ...request?.data?.schedule,
    id: request?.id,
    type: "open-shifts",
    user: request?.user,
    startDate: moment.parseZone(request?.data?.schedule?.startDate || request?.data?.startDate).tz(timezone, true),
    endDate: moment.parseZone(request?.data?.schedule?.endDate || request?.data?.endDate).tz(timezone, true),
    requestType: request?.type,
    status: request?.status,
    requiredToBeApprovedBy: request?.requiredToBeApprovedBy,
    job: request?.data?.schedule?.sections?.[0]?.job || request?.data?.job,
    location: request?.data?.schedule?.sections?.[0]?.location || request?.data?.location
});
